import { useSelector } from "react-redux";
import { Images } from "../../Assets/Index";
import { getLocalStorageItem } from "../../Utils";
import { IoCaretBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const Disclaimer = () => {
  const navigate = useNavigate();
  const walletBalance = useSelector((state) => state.colorGame.walletBal);
  return (
    <>
      <div className="flex justify-center pb-20 items-center bg-black rounded-lg">
        <div className="w-full ">
          <div className="flex justify-between bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f] px-8  py-2 gap-x-3 items-center ">
            <div className="text-white font-semibold flex  items-center gap-4 ">
              <IoCaretBack
                className="bg-[#ba7d13] h-7 w-7 rounded-lg cursor-pointer text-white"
                onClick={() => navigate("/home")}
              />
              <p className="text-xl font-normal custome">
                {getLocalStorageItem("userDetails")?.name}Disclaimer
              </p>
            </div>
            <div className="flex justify-between items-center">
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-white text-sm  custome">
                ₹0.00 {walletBalance}
              </p>
            </div>
          </div>
          <div className="overflow-y-scroll h-[90vh]">
            {" "}
            <div>
              <div className="m-8 bg-black ">
                <div
                  className=" gap-2 
                  items-center  mt-6 p-2"
                >
                  <div className="shadow-sm m-2 ">
                    <p className="text-base text-white custome font-medium mb-2">
                      Important Notice
                    </p>
                    <p className="text-sm text-white custome font-normal ">
                      If gambling,like Satta Matka , is illegal in your area,
                    </p>
                    <p className="text-sm text-white custome font-normal ">
                      please exit our app immediately.Our app is intended only
                    </p>
                    <p className="text-sm text-white custome font-normal mb-10">
                      for users where gambling is legal.
                    </p>
                    <p className="text-base text-white custome font-medium ">
                      Best Regards,
                    </p>
                    <p className="text-base text-white custome font-medium ">
                      CEO Jetx Matka Club of Games
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Disclaimer;
